import { UserApiUserUpdatePhoneRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useUserUpdatePhoneMutation = () =>
  useBaseMutation({
    mutationFn: (req: UserApiUserUpdatePhoneRequest, config) =>
      appApiClient.userApi.userUpdatePhone(req, config),
  })
